
import { Option } from '@/types/apptypes';
import Vue from 'vue';

export type Tab = Option&{
	class?: any,
	style?: CSSStyleDeclaration,
}

export default Vue.extend({
	props: {
		value: {required: false, type: [String, Number] },
		tabs: Array as () => Array<string|Option&{class?: string, style?: CSSStyleDeclaration}>,
		vertical: Boolean,
		flexy: Boolean,
		wrap: Boolean,
	},
	data: () => ({
		internalModel: -1,
	}),
	computed: {
		tabsModel(): Tab[] {
			return this.tabs.map((tab: Option|string) => {
				if (typeof tab === 'string') {
					return { label: tab, value: tab };
				}
				return tab;
			});
		},
		modelValue: {
			get(): {tab?: Tab, index: number} {
				if (typeof this.value === 'number') {
					return {tab: this.tabsModel[this.value], index: this.value};
				}
				if (typeof this.value === 'string') {
					const i = this.tabsModel.findIndex(tab => tab.value === this.value);
					return {tab: this.tabsModel[i], index: i};
				}
				else {
					return {tab: this.tabsModel[this.internalModel], index: this.internalModel};
				}
			},
			set(value: {tab: Tab, index: number}) {
				// emit either a number or a string, depending on what was put in.
				const emitValue = typeof this.value === 'string' ? value.tab.value : value.index;

				this.$emit('input', emitValue);
				this.internalModel = value.index;
			}
		}
	}
})

